var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 25,
    viewBox: "0 0 10 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M.006 19.14c.001 2.284 1.854 4.135 4.138 4.134 2.285 0 4.136-1.853 4.135-4.138l-.003-7.5-8.272.003.002 7.5z",
    transform: "translate(.347 .136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M0 4.138l.003 7.5 8.273-.003-.003-7.5C8.272 1.85 6.42-.001 4.135 0 1.85 0-.001 1.853 0 4.138",
    transform: "translate(.347 .136)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrags);
export default __webpack_public_path__ + "static/media/drags.048a581149ef3bbddbdbeba07bd1f75d.svg";
export { ForwardRef as ReactComponent };